"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const utils_1 = require("../utils");
const styles_1 = __importDefault(require("./styles"));
const checkboxStyle = styles_1.default({ checkbox: '.focusable-checkbox', label: 'label' });
const Checkbox = (_a) => {
    var { id, indeterminate, onChange, className, style = { margin: '10px 0' }, label, payload, whiteBackground, onBlur, onFocus, inline } = _a, rest = __rest(_a, ["id", "indeterminate", "onChange", "className", "style", "label", "payload", "whiteBackground", "onBlur", "onFocus", "inline"]);
    const [classNames, setClassNames] = react_1.useState(['focusable-checkbox']);
    const inputId = utils_1.useMemoizedId({ id, label });
    const backgroundColor = whiteBackground ? 'white' : undefined;
    react_1.useEffect(() => {
        if (indeterminate) {
            setClassNames(currentClassNames => [...currentClassNames, 'focusable-checkbox-indeterminate']);
        }
        else {
            setClassNames(currentClassNames => currentClassNames.filter(name => name !== 'focusable-checkbox-indeterminate'));
        }
    }, [indeterminate]);
    const onCheckBoxChange = e => onChange && onChange(e, payload);
    return (react_1.default.createElement("div", { className: emotion_1.cx(emotion_1.css `${checkboxStyle}`, className), style: Object.assign(Object.assign({}, style), { backgroundColor, display: inline ? 'inline' : 'block' }) },
        react_1.default.createElement("input", Object.assign({}, rest, { className: classNames.join(' '), onChange: onCheckBoxChange, onBlur: e => onBlur && onBlur(e), onFocus: e => onFocus && onFocus(e), type: "checkbox", id: inputId })),
        react_1.default.createElement("label", { htmlFor: inputId }, label)));
};
Checkbox.propTypes = {
    id: prop_types_1.default.string,
    checked: prop_types_1.default.bool,
    indeterminate: prop_types_1.default.bool,
    label: prop_types_1.default.node,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    whiteBackground: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    payload: prop_types_1.default.any,
    onBlur: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    style: react_style_proptype_1.default,
    inline: prop_types_1.default.bool,
};
Checkbox.defaultProps = {
    disabled: false,
    className: '',
    whiteBackground: false,
};
exports.default = Checkbox;
